(function () {
  if (window._productAccordionInit) return;
  window._productAccordionInit = true;

  // Click handler (delegated)
  function onAccordionClick(e) {
    // find a clicked accordion title inside .product__meta-grid
    const title = e.target.closest('.product__meta-grid .accordion-title');
    if (!title) return;

    // the panel is expected to be the next sibling
    const panel = title.nextElementSibling;
    if (!panel || !panel.classList.contains('panel')) return;

    // limit actions to the grid that contains this title
    const grid = title.closest('.product__meta-grid');
    if (!grid) return;

    // close other panels in the same grid
    const panels = grid.querySelectorAll('.panel');
    panels.forEach(p => {
      if (p !== panel) p.style.maxHeight = null;
    });

    // remove active from other titles in same grid
    const titles = grid.querySelectorAll('.accordion-title');
    titles.forEach(t => {
      if (t !== title) t.classList.remove('active');
    });

    // toggle current
    title.classList.toggle('active');

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      // set to scrollHeight so it animates open
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  // attach the delegated listener to document (catches dynamic content too)
  document.addEventListener('click', onAccordionClick, false);

  // Ensure any server-rendered ".active" accordions are opened on initial load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product__meta-grid .accordion-title.active').forEach(title => {
      const panel = title.nextElementSibling;
      if (panel && panel.classList.contains('panel')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
})();

// hero banner slider start here
// $('.hero-banner-main-slick').slick({
//   dots: true,
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 5000,
// });
// hero banner slider end here

const autoplaySpeedMS = 5000;
let progressTimer; // to control timing
let isChanging = false; // prevent conflicts between manual click & autoplay

// Initialize Slick
$('.hero-banner-main-slick').slick({
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: autoplaySpeedMS,
  arrows: false,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  fade: true,
  cssEase: 'linear',
  customPaging: function (slider, i) {
    return `
      <div class="progress-circle" data-index="${i}">
        <svg viewBox="0 0 36 36" width="12" height="12" aria-hidden="true" focusable="false">
          <circle class="circle-bg" cx="18" cy="18" r="15.9155" fill="none"/>
          <circle class="circle-progress" cx="18" cy="18" r="15.9155" fill="none"/>
        </svg>
      </div>`;
  },
});

// On init: prepare circle strokes
$('.hero-banner-main-slick').on('init', function (event, slick) {
  $('.slick-dots li svg .circle-progress').each(function () {
    const r = +$(this).attr('r');
    const circumference = 2 * Math.PI * r;
    $(this).css({
      'stroke-dasharray': circumference,
      'stroke-dashoffset': circumference,
    });
  });
});

// When slick is ready
$('.hero-banner-main-slick').on('setPosition', function (event, slick) {
  if (!isChanging) {
    startProgressAnimation(slick.currentSlide);
  }
});

// Before slide change
$('.hero-banner-main-slick').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  isChanging = true;
  resetProgressAnimation(currentSlide);
  clearTimeout(progressTimer);
});

// After slide change
$('.hero-banner-main-slick').on('afterChange', function (event, slick, currentSlide) {
  startProgressAnimation(currentSlide);
  isChanging = false;
});

// Handle dot clicks
$(document).on('click', '.slick-dots li', function () {
  const index = $(this).index();
  const $slider = $('.hero-banner-main-slick');

  if (isChanging) return; // prevent multiple triggers

  isChanging = true;
  clearTimeout(progressTimer);
  resetAllProgressAnimations();

  // Change slide instantly and restart autoplay
  $slider.slick('slickGoTo', index, false);
  $slider.slick('slickPlay');

  // Restart timer after small delay
  setTimeout(() => {
    startProgressAnimation(index);
    isChanging = false;
  }, 200);
});

function startProgressAnimation(index) {
  clearTimeout(progressTimer);
  const $current = $('.slick-dots li').eq(index).find('.circle-progress');
  if (!$current.length) return;

  const r = +$current.attr('r');
  const circumference = 2 * Math.PI * r;

  $current.css({
    'transition': `stroke-dashoffset ${autoplaySpeedMS}ms linear`,
    'stroke-dasharray': circumference,
    'stroke-dashoffset': circumference,
  });

  setTimeout(() => $current.css('stroke-dashoffset', 0), 50);

  // auto restart next timer after autoplaySpeedMS
  progressTimer = setTimeout(() => {
    const $slider = $('.hero-banner-main-slick');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('slickNext');
    }
  }, autoplaySpeedMS);
}

function resetProgressAnimation(index) {
  const $prev = $('.slick-dots li').eq(index).find('.circle-progress');
  if (!$prev.length) return;
  const r = +$prev.attr('r');
  const circumference = 2 * Math.PI * r;
  $prev.css({
    'transition': 'none',
    'stroke-dashoffset': circumference,
  });
}

function resetAllProgressAnimations() {
  $('.circle-progress').each(function () {
    const r = +$(this).attr('r');
    const circumference = 2 * Math.PI * r;
    $(this).css({
      'transition': 'none',
      'stroke-dashoffset': circumference,
    });
  });
}


